import { recipe } from "@vanilla-extract/recipes";
import { style, globalStyle, keyframes } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { avatarStyle } from "../Avatar/Avatar.css";

const rotateAnimation = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

export const iconStyle = recipe({
  base: {
    flexGrow: 0,
    flexShrink: 0,
    display: "inline-block",
    lineHeight: 1,
    verticalAlign: "middle",
    selectors: {
      [`${avatarStyle} &`]: {
        zIndex: 2,
      },
    },
  },
  variants: {
    size: {
      xxxs: { width: rem(6), height: rem(6) },
      xxs: { width: rem(8), height: rem(8) },
      xs: { width: rem(12), height: rem(12) },
      xs2: { width: rem(14), height: rem(14) },
      s: { width: theme.spacings.s, height: theme.spacings.s },
      s1: { width: rem(18), height: rem(18) },
      s2: { width: rem(22), height: rem(22) },
      m: { width: theme.spacings.m, height: theme.spacings.m },
      l: { width: theme.spacings.l, height: theme.spacings.l },
      xl: { width: theme.spacings.xl, height: theme.spacings.xl },
      xxl: { width: rem(80), height: rem(80) },
    },
    animation: {
      rotation: {
        animation: `${rotateAnimation} 3s ease-in-out infinite`,
      },
    },
  },
});

export const gradientStyle = style({});

globalStyle(
  `${gradientStyle} path, ${gradientStyle} circle, ${gradientStyle} rect, ${gradientStyle} polygon`,
  {
    fill: "url(#huub-gradient) !important",
  },
);
